import "../styles/globals.css";
import {ThemeProvider} from "next-themes";
import Layout from "../components/layout";
import {Provider} from "react-redux";
import {store} from "../redux/store";
import UserContext from "../components/UserContext";
import {useRef} from "react";
import {Analytics} from '@vercel/analytics/react';
import {GoogleAnalytics} from '@next/third-parties/google';
import Head from "next/head";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Engineering Book Club",
  "url": "https://www.engineeringbookclub.com",
  "logo": "https://www.engineeringbookclub.com/favicon.png",
  "sameAs": [
    "https://x.com/TheEngBookClub",
    "https://www.linkedin.com/company/engineering-book-club"
  ]
};

function MyApp({Component, pageProps}) {
  const scrollRef = useRef({
    scrollPos: 0,
  });

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html: JSON.stringify(organizationJsonLd)}}
        />
      </Head>
      <Provider store={store}>
        <ThemeProvider enableSystem={true} attribute="class">
          <UserContext.Provider value={{scrollRef: scrollRef}}>
            <Layout>
              <Component {...pageProps} />
              <GoogleAnalytics gaId="G-DHGMT2PRV3"/>
              <script async src="https://cdn.splitbee.io/sb.js"></script>
              <script async src="https://cdn.seline.com/seline.js" data-token="696a2f6c42c89f7"></script>
            </Layout>
          </UserContext.Provider>
        </ThemeProvider>
      </Provider>
      <Analytics/>
    </>
  );
}

export default MyApp;
